var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "donut",
    _vm._b(
      { attrs: { chartdata: _vm.chartdata, options: _vm.chartOptions } },
      "donut",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }